module.exports = __webpack_public_path__ + "static/img/图层14.acbf979.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cardSolution/图层14.png
// module id = yKwx
// module chunks = 0